module.exports = __webpack_public_path__ + "static/img/labour-love-3.12ca387.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/labour-love-3.svg
// module id = +6p6
// module chunks = 1